import React, {
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';
import type { ReactNode } from 'react';

import type { FilterScalarValue } from '../../features/practitioner/lib/filterTypes';

export interface PractitionerFilterState {
  office: boolean;
  iprp: boolean;
  pssm: boolean;
  referringHandicap: boolean;
  gpAudio: boolean;
  gpVisio: boolean;
  passedPresta: boolean;
}

interface PractitionerFilterContextValue {
  state: PractitionerFilterState;
  setState: React.Dispatch<React.SetStateAction<PractitionerFilterState>>;
  officeSpecialistSpecialities: FilterScalarValue;
  setOfficeSpecialistSpecialities: React.Dispatch<React.SetStateAction<FilterScalarValue>>;
}

const defaultState: PractitionerFilterState = {
  office: false,
  iprp: false,
  pssm: false,
  referringHandicap: false,
  gpAudio: false,
  gpVisio: false,
  passedPresta: false,
};

const PractitionerFilterContext = createContext<PractitionerFilterContextValue | null>(null);

export function PractitionerFilterProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<PractitionerFilterState>(defaultState);
  const [officeSpecialistSpecialities, setOfficeSpecialistSpecialities] = useState<FilterScalarValue>(false);

  const value = useMemo(
    () => ({
      state,
      setState,
      officeSpecialistSpecialities,
      setOfficeSpecialistSpecialities,
    }),
    [state, officeSpecialistSpecialities],
  );

  return (
    <PractitionerFilterContext.Provider value={value}>
      {children}
    </PractitionerFilterContext.Provider>
  );
}

export function usePractitionerFilters(): PractitionerFilterContextValue {
  const context = useContext(PractitionerFilterContext);
  if (!context) {
    throw new Error('usePractitionerFilters must be used within PractitionerFilterProvider');
  }
  return context;
}
